import { useEffect, useState } from 'react';

const STEPS = [
	{
		title: 'Оформление заказа',
		text: 'Оформляете заказ и платите картой через ЮKassa.',
	},
	{
		title: 'Резервирование',
		text: 'Сумма резервируется на карте. Это ещё не списание.',
	},
	{
		title: 'Оплата',
		text: 'Списываем фактическую сумму заказа.',
	},
	{
		title: 'Возврат',
		text: 'Если заказ дешевле резерва — разница возвращается на карту. Отмена снимает резерв целиком.',
	},
];

const YookassaHoldSteps = () => {
	const [step, setStep] = useState(0);

	useEffect(() => {
		const timer = setInterval(() => {
			setStep(current => (current + 1) % STEPS.length);
		}, 3200);
		return () => clearInterval(timer);
	}, []);

	return (
		<section className='yk-hold' aria-label='Как работает оплата через ЮKassa'>
			<h3 className='yk-hold-title'>Оплата картой</h3>
			<p className='yk-hold-lead'>Сначала сумма резервируется, потом списывается оплата.</p>
			<ol className='yk-hold-steps'>
				{STEPS.map((item, index) => (
					<li
						key={item.title}
						className={`yk-hold-step${index === step ? ' is-active' : ''}${
							index < step ? ' is-done' : ''
						}`}
					>
						<span className='yk-hold-index'>{index + 1}</span>
						<span className='yk-hold-step-title'>{item.title}</span>
					</li>
				))}
			</ol>
			<p className='yk-hold-caption' key={step}>
				{STEPS[step].text}
			</p>
			<HoldScene step={step} />
		</section>
	);
};

const SCENES = [
	{
		title: '1. Оформление заказа',
		note: 'Картой через ЮKassa',
		figure: 'pay',
	},
	{
		title: '2. Резервирование',
		note: '1 500 ₽ в резерве',
		figure: 'hold',
	},
	{
		title: '3. Оплата',
		note: 'Списали 1 200 ₽',
		figure: 'pack',
	},
	{
		title: '4. Возврат',
		note: '300 ₽ вернулись',
		figure: 'back',
	},
];

const HoldScene = ({ step }) => (
	<div className='yk-scene' aria-hidden='true'>
		{SCENES.map((scene, index) => (
			<div
				key={scene.title}
				className={`yk-scene-card${index === step ? ' is-active' : ''}`}
			>
				<div className={`yk-fig yk-fig-${scene.figure}`}>
					{scene.figure === 'pay' && (
						<>
							<span className='yk-fig-person' />
							<span className='yk-fig-card'>1 500 ₽</span>
						</>
					)}
					{scene.figure === 'hold' && (
						<>
							<span className='yk-fig-card is-frozen'>1 500 ₽</span>
							<span className='yk-fig-lock'>замок</span>
						</>
					)}
					{scene.figure === 'pack' && (
						<>
							<span className='yk-fig-box'>заказ</span>
							<span className='yk-fig-card is-small'>1 200 ₽</span>
						</>
					)}
					{scene.figure === 'back' && (
						<>
							<span className='yk-fig-person' />
							<span className='yk-fig-coin'>300 ₽</span>
						</>
					)}
				</div>
				<p className='yk-scene-title'>{scene.title}</p>
				<p className='yk-scene-note'>{scene.note}</p>
			</div>
		))}
	</div>
);

export default YookassaHoldSteps;
